import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {WifiPoint} from '../../interfaces/WifiPoint';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

interface Props extends Omit<DialogProps, 'onClose'> {
  item: WifiPoint;
  action: 'device' | 'data';
  onSubmitted?: () => void;
  onClose?: () => void;
}

const WifiPointItemPurgeModal = ({
  item,
  action,
  onSubmitted,
  onClose,
  ...props
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const actionName = action === 'data' ? 'Purge Transactions' : 'Purge Device';

  const submit = async (pk: number) => {
    setIsSubmitting(true);
    try {
      await API.post(`${apiBaseUrl}/purge`, {wifi_point_ids: [pk], action});
      const message = `${action === 'data' ? 'Wifi Point Transactions' : 'Wifi Point Device'} successfully purged`;
      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.();
      onClose?.();
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_99f12d60");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsSubmitting(false);
  };

  return (
    <Dialog {...props} onClose={onClose}>
      <DialogTitle>Wifi Point: {actionName}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to purge {actionName} of this wifi point?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose?.()}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          autoFocus
          onClick={() => submit(item.id)}
          color="warning"
        >
          {actionName}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default WifiPointItemPurgeModal;
